module.exports = __webpack_public_path__ + "static/media/verification.ece6664b.png";